import React, { Component } from "react";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import Badge from "./Badge/Badge";
import * as notificationActions from "../domain/notifications/notificationActions";
import { getUserInfo } from "../../api/axios";

class UnreadCountBadge extends Component {
    componentDidMount() {
        // Load counts only once when component mounts
        this.loadUnreadCounts();
    }

    loadUnreadCounts = () => {
        const { notificationReducer } = this.props;
        const { unreadCountsLoading } = notificationReducer;

        // Only load if not already loading
        if (!unreadCountsLoading) {
            this.props.notificationActions.getUnseenCounts();
        }
    };

    render() {
        const { notificationReducer } = this.props;
        const { unreadCount, unreadCountsLoading } = notificationReducer;

        if (unreadCountsLoading || unreadCount === 0) {
            return null;
        }

        return (
            <Badge
                color="red"
                size="mini"
                className="notification-badge"
                content={unreadCount > 99 ? "99+" : unreadCount}
            />
        );
    }
}

const mapStateToProps = (state) => ({
    notificationReducer: state.notificationReducer,
    currentUser: state.accountReducer?.userInfo,
});

const mapDispatchToProps = (dispatch) => ({
    notificationActions: bindActionCreators(notificationActions, dispatch),
});

export default connect(mapStateToProps, mapDispatchToProps)(UnreadCountBadge);
